import type { FracDesign } from './types';

export const simulationHandoffUrl = (designId: number): string =>
  `/fracsim/overview?design_id=${encodeURIComponent(String(designId))}`;

export const parseSimulationHandoff = (search: string): { designId: number | null; error: string | null } => {
  const raw = new URLSearchParams(search).get('design_id');
  if (raw === null) return { designId: null, error: null };
  if (!/^[1-9]\d*$/.test(raw) || !Number.isSafeInteger(Number(raw))) {
    return { designId: null, error: '设计方案编号无效，请从压裂设计页面重新进入模拟。' };
  }
  return { designId: Number(raw), error: null };
};

export const summarizeSimulationDesignInput = (design: FracDesign) => {
  const stages = design.stages ?? [];
  const scheduledStages = stages.filter((stage) => Array.isArray(stage.schedule) && stage.schedule.length > 0);
  const unscheduledStageNumbers = stages.filter((stage) => !Array.isArray(stage.schedule) || stage.schedule.length === 0)
    .map((stage) => stage.stage_number);
  const fluidM3 = stages.reduce((sum, stage) => sum + (Number(stage.fluid_volume) || 0), 0);
  const proppantT = stages.reduce((sum, stage) => sum + (Number(stage.proppant_mass) || 0), 0);
  return {
    stageCount: stages.length,
    scheduledStageCount: scheduledStages.length,
    unscheduledStageNumbers,
    fluidM3,
    proppantT,
    countMismatch: stages.length !== design.stage_count,
  };
};
